/**
 * Shared Calculator Methods
 */
const $ = window.jQuery;
const dataLayer = window.dataLayer;
import { toNumber, get, find, includes } from "lodash-es";

// Autonumeric Config: USD Dollar
export const dollarConfig = {
  createLocalList: false,
  currencySymbol: "$",
  decimalPlaces: 0,
  decimalPlacesRawValue: 0,
  emptyInputBehavior: "zero",
  modifyValueOnWheel: false,
  outputFormat: "number",
  symbolWhenUnfocused: "",
  unformatOnHover: false,
};

// Autonumeric Config: Percentage
export const percentageConfig = {
  caretPositionOnFocus: "start",
  createLocalList: false,
  decimalPlaces: 3,
  decimalPlacesRawValue: 3,
  emptyInputBehavior: "zero",
  modifyValueOnWheel: false,
  suffixText: "%",
  symbolWhenUnfocused: "",
  outputFormat: "number",
  unformatOnHover: false,
};

// Equivalent of Excel PMT
export function PMT(rate, periods, present, future, type) {
  future = future || 0;
  type = type || 0;

  rate = toNumber(rate);
  periods = toNumber(periods);
  present = toNumber(present);
  future = toNumber(future);
  type = toNumber(type);

  // Return payment
  var result;
  if (rate === 0) {
    result = (present + future) / periods;
  } else {
    var term = Math.pow(1 + rate, periods);
    if (type === 1) {
      result = ((future * rate) / (term - 1) + (present * rate) / (1 - 1 / term)) / (1 + rate);
    } else {
      result = (future * rate) / (term - 1) + (present * rate) / (1 - 1 / term);
    }
  }
  return -result;
}

// Currency formatter
export function usd(int) {
  return int.toLocaleString("en-US", {
    style: "currency",
    currency: "USD",
  });
}

export function PV(rate, periods, payment, future, type) {
  // Initialize type
  type = typeof type === "undefined" ? 0 : type;

  // Evaluate rate and periods (TODO: replace with secure expression evaluator)
  rate = toNumber(rate);
  periods = toNumber(periods);

  // Return present value
  if (rate === 0) {
    return -payment * periods - future;
  } else {
    return (((1 - Math.pow(1 + rate, periods)) / rate) * payment * (1 + rate * type) - future) / Math.pow(1 + rate, periods);
  }
}

export function FV(rate, periods, payment, value, type) {
  // Credits: algorithm inspired by Apache OpenOffice

  value = value || 0;
  type = type || 0;

  // Return future value
  var result;
  if (rate === 0) {
    result = value + payment * periods;
  } else {
    var term = Math.pow(1 + rate, periods);
    if (type === 1) {
      result = value * term + (payment * (1 + rate) * (term - 1)) / rate;
    } else {
      result = value * term + (payment * (term - 1)) / rate;
    }
  }
  return -result;
}

export function CUMIPMT(rate, periods, value, start, end, type) {
  // Evaluate rate and periods (TODO: replace with secure expression evaluator)
  rate = toNumber(rate);
  periods = toNumber(periods);

  // Return error if either rate, periods, or value are lower than or equal to zero
  if (rate <= 0 || periods <= 0 || value <= 0) return "#NUM!";

  // Return error if start < 1, end < 1, or start > end
  if (start < 1 || end < 1 || start > end) return "#NUM!";

  // Return error if type is neither 0 nor 1
  if (type !== 0 && type !== 1) return "#NUM!";

  // Compute cumulative interest
  var payment = PMT(rate, periods, value, 0, type);
  var interest = 0;
  interest = 0;
  if (start === 1) {
    if (type === 0) {
      interest = -value;
      start++;
    }
  }
  for (var i = start; i <= end; i++) {
    if (type === 1) {
      interest += FV(rate, i - 2, payment, value, 1) - payment;
    } else {
      interest += FV(rate, i - 1, payment, value, 0);
    }
  }
  interest *= rate;

  // Return cumulative interest
  return interest;
}

// Custom select dropdowns
export function customDropdowns() {
  $(() => {
    $('[data-dropdown="select2"]').select2({
      minimumResultsForSearch: -1,
    });
  });
}

// Number to currency
export function numberToCurrency(int) {
  return Number(int).toLocaleString("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });
}

// Number format
export function numberFormat(number, decimals, dec_point, thousands_sep) {
  var n = !isFinite(+number) ? 0 : +number,
    prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
    sep = typeof thousands_sep === "undefined" ? "," : thousands_sep,
    dec = typeof dec_point === "undefined" ? "." : dec_point,
    toFixedFix = function (n, prec) {
      // Fix for IE parseFloat(0.55).toFixed(0) = 0;
      var k = Math.pow(10, prec);
      return Math.round(n * k) / k;
    },
    s = (prec ? toFixedFix(n, prec) : Math.round(n)).toString().split(".");

  if (s[0].length > 3) {
    s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
  }

  if ((s[1] || "").length < prec) {
    s[1] = s[1] || "";
    s[1] += new Array(prec - s[1].length + 1).join("0");
  }

  return s.join(dec);
}

// Mark field as valid
export function markFieldAsValid(element) {
  let id = element.attr("id");
  let errorMsg = $(`#${id}-error`);

  errorMsg.fadeOut();
  element.parent(".form-field").removeClass("form-field--error");
}

// Mark field as invalid
export function markFieldAsInvalid(element) {
  let id = element.attr("id");
  let errorMsg = $(`#${id}-error`);

  errorMsg.fadeIn();
  element.parent(".form-field").addClass("form-field--error");
}

// Logging
function log(label, data) {
  console.log("%c " + label + " ", "background-color:#0000ff; color:white; font-weight:bold");
  console.log("%c " + JSON.stringify(data) + " ", "color:#0000ff; background:#fff; font-weight:bold");
}

// Track event
//
// Category is pushed verbatim so it matches the GTM triggers, which compare
// against the exact string ("Mortgage Calculator Submitted").
export function trackEvent(category, action, label, value) {
  var data = {
    event: "Track Event",
    category: category,
    action: action,
    label: label,
    value: value,
  };

  log("Tracked Event", data);
  dataLayer.push(data);
}

// Find RI or MA taxes for ZIP code
export async function findPropertyTaxForZipCode(zipCodeInput) {
  const json = await $.getJSON("/wp-content/themes/coastal1/assets/js/property-taxes.json?v=0.0.2");
  let municipalities = get(json, "municipalities", []);

  let city = find(municipalities, (city) => {
    let zips = get(city, "zip", []);
    return includes(zips, zipCodeInput);
  });

  let propertyTaxRate = get(city, "propertyTax", 10.0);

  return propertyTaxRate;
}
